import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        // height: 80,
        backgroundColor: sicrediStyle.primarySicredi,
        boxSizing: 'border-box',
      },
      actionsRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16,
      },
      search: {
        display: 'flex',
        flexShrink: 0,
        width: 321,
        boxSizing: 'border-box',
      },
      input: {
        '& .MuiInputLabel-root': {
          color: 'white',
        },
        '& .MuiInput-root': {
          color: 'white',
        },
        '& .MuiInput-underline:before': {
          borderBottomColor: 'white',
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: 'white',
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
          borderBottomColor: 'white',
        }
      },
      headline: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 0,
        boxSizing: 'border-box',
        overflow: 'hidden',
      },
      title: {
        width: '100%',
        color: 'white',
        fontSize: 32,
        lineHeight: '1.2em',
        fontWeight: 500,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
      actionButtons: {
        paddingLeft: 16,
        marginTop: -8,
        marginBottom: -8,
      },
      actionButton: {
        flexShrink: 0,
        backgroundColor: 'white',
        color: sicrediStyle.primarySicrediDark,
        fontSize: 14,
        fontWeight: 'bold',
        marginRight: 16,
        marginTop: 8,
        marginBottom: 8,
        '&:last-child': {
          marginRight: 0
        }
      },
    }),
  { name: 'MensagensAssessor' }
);
